/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import "./AppPanelHeader.scss";
import OECSLogo from "../../assets/images/logos/OECSLogo.png";
import XIcon from "@material-ui/icons/Close";
import { clearQueryStrings } from "../../hooks/queryString";

function AppPanelHeader({ title, setApp, hideClose }) {

  const clearApp = () => {
    clearQueryStrings();
    setApp(null);
  }

  return (
    <header className="appPanelHeader">
      { title === 'Get Started' && (
        <img
          className="oecsLogo"
          src={OECSLogo}
          alt="Organisation of Eastern Caribbean States"
          title="Organisation of Eastern Caribbean States"
        />
      )}
      <div>
        {title}
      </div>
      <div onClick={() => clearApp()} to="/" className="appPanelHeaderX">
        <XIcon hidden={hideClose}></XIcon>
      </div>
    </header>
  );
}

export default AppPanelHeader;
